import { css } from '@compiled/react';

import { Button } from '@/libraries/design/components/button/src/button';
import { useSiteActivationContext } from '../../hooks/site-activation-context';

export const SubmitButton = ({ submitMessage }: { submitMessage: string }) => {
	const { isSubmitting, hasSubmitted } = useSiteActivationContext();
	return (
		<Button
			css={buttonCss}
			type="submit"
			isDisabled={isSubmitting || hasSubmitted}
			isLoading={isSubmitting || hasSubmitted}
		>
			{submitMessage}
		</Button>
	);
};

const buttonCss = css({
	borderRadius: 6,
	fontFamily: 'inherit',
	fontSize: 14,
	maxWidth: 'auto',
	paddingBlock: 8,
	width: '100%',
});
